export const BRAND_NAME = 'Evisort';
export const BRAND_PRODUCT_TAGLINE = `Contract Intelligence (${BRAND_NAME})`;
export const BRAND_TERMS_OF_USE_LABEL = `Workday ${BRAND_NAME}'s Terms of Use`;
